import { useCallback, useState } from "react";
import { message } from "antd";
import { getProjectTracking } from "../../api/projectApi";

export default function useProjectTracking() {
  const [tracking, setTracking] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchTracking = useCallback(async (id) => {
    if (!id) return null;

    setLoading(true);
    try {
      const data = await getProjectTracking(id);
      setTracking(data);
      return data;
    } catch (error) {
      console.error(error);
      message.error("Failed to load tracking progress");
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return { tracking, loading, fetchTracking };
}